module.exports = __webpack_public_path__ + "img/1400_YR_2022_Background.36eb6188.png";